module.exports = __webpack_public_path__ + "static/media/alliances.6bcbefcf.svg";